module.exports = __webpack_public_path__ + "img/service5.a105288e.png";